module.exports = __webpack_public_path__ + "preview-eac7acfc/open-sans-condensed-light-6ef10d5786ccfd937c8efd40e75f0aad.woff";